import currentUserStore from 'stores/CurrentUserStore';
import {
  BIN_DATA_MANAGEMENT_VIEW,
  BIN_DATA_MANAGEMENT_VIEW_AND_EDIT,
} from '@mqd/mqd-constants/src/uamGranularPermissions';

export const requirements = {
  flipFlopRequirements: ['bin-data-management-active'],
  requiredUserPermissions: [
    'manage-bin-data-internal',
    'view-bin-data-internal',
    BIN_DATA_MANAGEMENT_VIEW,
    BIN_DATA_MANAGEMENT_VIEW_AND_EDIT,
  ],
};

export const verifier = () => {
  const { userStore = {} } = currentUserStore;
  const { canViewBinDataManagement } = userStore;

  return canViewBinDataManagement;
};
